var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-2user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.39635 10.4641C8.30469 10.4549 8.19469 10.4549 8.09385 10.4641C5.91219 10.3908 4.17969 8.60327 4.17969 6.40327C4.17969 4.15744 5.99469 2.33327 8.24969 2.33327C10.4955 2.33327 12.3197 4.15744 12.3197 6.40327C12.3105 8.60327 10.578 10.3908 8.39635 10.4641Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.042 4.16661C16.8204 4.16661 18.2504 5.60577 18.2504 7.37494C18.2504 9.10744 16.8754 10.5191 15.1612 10.5833C15.0879 10.5741 15.0054 10.5741 14.9229 10.5833",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.81316 13.8466C1.59483 15.3316 1.59483 17.7516 3.81316 19.2274C6.334 20.9141 10.4682 20.9141 12.989 19.2274C15.2073 17.7424 15.2073 15.3224 12.989 13.8466C10.4773 12.1691 6.34316 12.1691 3.81316 13.8466Z",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.8115 18.8333C17.4715 18.6958 18.0949 18.4299 18.6082 18.0358C20.0382 16.9633 20.0382 15.1941 18.6082 14.1216C18.104 13.7366 17.4899 13.4799 16.839 13.3333",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fc3a4a0e8580167c942455938f18d708.svg";
export { ForwardRef as ReactComponent };